<template>
  <main class="main main__profile" role="main">
    <section-header>
      <h2 v-html="$t('profile.removeAccount')"/>
    </section-header>

    <section-page>
      <div class="row">
        <div class="col col3 asideMenu">
          <ul>
            <li><a href="/user/profile#myData" class="bt_scroll">{{$t('profile.myData')}}<i class="fa fa-arrow-right"/></a></li>
            <li><a href="/user/profile#myPassword" class="bt_scroll">{{$t('profile.password')}}<i class="fa fa-arrow-right"/></a></li>
            <li><NuxtLink href="#" to="/user/reservations" class="bt_scroll">{{$t('profile.myTickets')}}<i class="fa fa-arrow-right"/></NuxtLink></li>
            <li><a href="#" class="bt_scroll" @click.prevent="logout">{{$t('profile.logout')}}<i class="fa-solid fa-right-from-bracket"/></a></li>
            <li><NuxtLink href="#" to="/user/removeAccount" class="bt_scroll delete">{{$t('profile.removeAccount')}}<i class="fa-solid fa-trash"/></NuxtLink></li>
          </ul>
        </div>
        <div class="gap col1"/>
        <div class="col col6">
          <RemoveAccountRequest id="myData" :bubble-title="$t('profile.removeAccount')"/>
        </div>
      </div>
    </section-page>
  </main>
</template>
<script setup lang="ts">
import SectionHeader from "~/components/sections/SectionHeader.vue";
import SectionPage from "~/components/sections/SectionPage.vue";
import api from "~/api";
import RemoveAccountRequest from "~/components/users/RemoveAccountRequest.vue";

definePageMeta({
  layout: 'base-layout',
  middleware: 'auth'
})

const logout = async () => {
  await api.Auth.logout();
  navigateTo('/')
}
</script>